import { useEffect, useRef } from 'react';
import analyticsTracker from '../utils/analyticsTracker';

export function useAnalyticsSession(user) {
  const initialized = useRef(false);

  useEffect(() => {
    if (user && !initialized.current) {
      analyticsTracker.init(user.id);
      initialized.current = true;
    }

    const handleBeforeUnload = () => {
      analyticsTracker.endSession();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        analyticsTracker.endSession();
      } else if (document.visibilityState === 'visible' && user) {
        analyticsTracker.init(user.id);
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [user]);
}
